import * as Actions from "./actions";
import { initialState } from "../store/initialState";

export const DeparmentsReducer = (state = initialState.departments, action) => {
  switch (action.type) {
    case Actions.DELETE_DEPARTMENT:
      return {
        ...state,
        list: [...action.payload], //新しい配列として更新する。コンポーネント側で変更を検知するため。
      };
    case Actions.FETCH_DEPARTMENT:
      return {
        ...state,
        list: [...action.payload], //新しい配列として更新する。コンポーネント側で変更を検知するため。
      };
    case Actions.INIT_DEPARTMENT:
      return {
        ...initialState.departments,
      };
    default:
      return state;
  }
};
